import {connect} from '@gisatcz/ptr-state';

import Action from "../../state/Action";
import Select from "../../state/Select";

import presentation from './presentation';

const mapStateToProps = (state, ownProps) => {
	return {
		layerStylesConfig: Select.specific.eo4sdDrrInsarMyanmar20.getLayersStyleConfig(state),
		pairConfig: Select.specific.eo4sdDrrInsarMyanmar20.getPairConfig(state),
		styles: Select.styles.getAllAsObject(state),
		activeMap: Select.maps.getActiveMap(state),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addVectorLayer: (mapKey, layer, index) => {
			dispatch(Action.maps.addMapLayerToIndex(mapKey, layer, index));
		},
		removeVectorLayer: (mapKey, layerKey) => {
			dispatch(Action.maps.removeMapLayer(mapKey, layerKey));
		},
		changeActiveLayerStyle: (layerKey, styleKey) => {
			dispatch(Action.app.setLocalConfiguration(`data.layerStyles.${layerKey}.active`, styleKey))
		},
		setLayerStyle: (mapKey, layerKey, style) => {
			dispatch(Action.maps.setMapLayerOption(mapKey, layerKey, 'style', style))
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
